module.exports = __webpack_public_path__ + "img/short.5433fe6e.png";